import React from 'react';
import { FiMoreVertical } from 'react-icons/fi';
import { iconButtonStyles } from '../../styles/commonStyles';
import ButtonWithIcon from './ButtonWithIcon';

const MoreButton = ({ onClick }) => (
    <ButtonWithIcon
        Icon={FiMoreVertical}
        onClick={onClick}
        className={iconButtonStyles}
    />
);

export default MoreButton;
